<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.49939 1.66663C10.2508 1.66663 10.9715 1.96513 11.5029 2.49648L17.6264 8.62002H17.6264C18.5695 9.56299 18.5694 11.092 17.6264 12.035L12.0353 17.626C11.0923 18.569 9.56335 18.5691 8.62039 17.626L2.49685 11.5025C1.9655 10.9711 1.66699 10.2505 1.66699 9.49902V4.09995C1.66699 2.75606 2.75642 1.66663 4.10032 1.66663H9.49939ZM3.33364 9.49902C3.33364 9.80844 3.45657 10.1052 3.67537 10.324L9.7989 16.4475L9.79895 16.4476C10.091 16.7396 10.5646 16.7397 10.8568 16.4475L16.4479 10.8564C16.7401 10.5643 16.74 10.0906 16.4479 9.79858L16.4479 9.79854L10.3243 3.675C10.1055 3.45621 9.80881 3.33328 9.49939 3.33328H4.10032C3.6769 3.33328 3.33364 3.67653 3.33364 4.09995V9.49902Z"
      fill="#666666"
      class="fill"
    />
    <path
      d="M5.04655 5.04667C5.48101 4.61221 6.18538 4.61221 6.61984 5.04667L6.63327 5.06007C7.06772 5.49453 7.06772 6.19893 6.63327 6.63339C6.19881 7.06785 5.49441 7.06785 5.05995 6.63339L5.04655 6.61996C4.61209 6.1855 4.61209 5.48113 5.04655 5.04667Z"
      fill="#666666"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill,
.active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke,
.active svg .stroke {
  stroke: #df252a;
}

.primary svg .fill {
  fill: #4478ff;
}

.primary svg .stroke {
  stroke: #4478ff;
}
</style>
